export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Bold.969916e0.ttf";